import type { ReportListResponse, TaskStatus } from '../../types';

const STATUS_LABEL: Record<string, string> = {
  pending: '排队中',
  processing: '评测中',
  success: '已完成',
  partial_failed: '部分完成',
  failed: '失败',
  timeout: '超时'
};
interface Props {
  data: ReportListResponse | null;
  loading: boolean;
  error: string;
  selectedId?: string;
  status: TaskStatus | '';
  onStatus: (value: TaskStatus | '') => void;
  onSelect: (id: string) => void;
  onPage: (page: number) => void;
  onRetry: () => void;
}
export function ReportList({
  data,
  loading,
  error,
  selectedId,
  status,
  onStatus,
  onSelect,
  onPage,
  onRetry
}: Props) {
  return (
    <aside className="report-list">
      <div className="report-list-head">
        <div>
          <h3>我的评测报告</h3>
          <span>仅展示当前独立账号的数据</span>
        </div>
        <select
          aria-label="筛选报告状态"
          value={status}
          onChange={(e) => onStatus(e.target.value as TaskStatus | '')}
        >
          <option value="">全部状态</option>
          <option value="processing">评测中</option>
          <option value="success">已完成</option>
          <option value="partial_failed">部分完成</option>
          <option value="failed">失败</option>
          <option value="timeout">超时</option>
        </select>
      </div>
      {loading ? (
        <div className="state-box">
          <span className="spinner dark" />
          正在加载报告…
        </div>
      ) : error ? (
        <div className="state-box error">
          <p>{error}</p>
          <button className="btn secondary" onClick={onRetry}>
            重新加载
          </button>
        </div>
      ) : !data?.list.length ? (
        <div className="state-box">
          <strong>暂无评测报告</strong>
          <p>创建首个任务后，报告会显示在这里。</p>
        </div>
      ) : (
        <>
          <div className="report-items">
            {data.list.map((item) => (
              <button
                key={item.id}
                className={`report-item ${selectedId === item.id ? 'active' : ''}`}
                onClick={() => onSelect(item.id)}
              >
                <span>
                  <strong>{item.task_name || '未命名任务'}</strong>
                  <small>
                    {item.mode === 'compare' ? '双篇对比' : '单篇评估'} ·{' '}
                    {new Date(item.created_at).toLocaleString('zh-CN', { hour12: false })}
                  </small>
                  <em className={`status-badge status-${item.status}`}>
                    {STATUS_LABEL[item.status] || item.status}
                  </em>
                </span>
                <b className="report-score">{item.overall_score ?? '—'}</b>
              </button>
            ))}
          </div>
          <div className="pagination">
            <button disabled={data.page <= 1} onClick={() => onPage(data.page - 1)}>
              上一页
            </button>
            <span>
              {data.page} / {Math.max(1, data.total_pages)}
            </span>
            <button disabled={data.page >= data.total_pages} onClick={() => onPage(data.page + 1)}>
              下一页
            </button>
          </div>
        </>
      )}
    </aside>
  );
}
